import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

import {searchFormConfig} from './config/oa.search.config'
import {contentTableConfig} from './config/oa.content.config'
import {modalConfig} from './config/oa.modal.config'
import {usePageSearch} from '@/hooks/userPageSearch'
import {usePageModal} from '@/hooks/usePageModal'
import {ref} from 'vue'
import PageSearch from '@/components/PageSearch.vue'
import PageContent from '@/components/PageContent.vue'
import PageModal from '@/components/PageModal.vue'
import {useStore} from "@/store";


export default /*#__PURE__*/_defineComponent({
  __name: 'OA',
  setup(__props) {

const store = useStore()
const modalTitle = ref('新增')
const newCb = () => {
  modalTitle.value = '新增'
}

const editCb = () => {
  modalTitle.value = '编辑'
}

const handleSortChange = (value: any) => {
  console.log(value)
  store.commit('system/changeOrderInfo', {
    orderBy: value.prop,
    orderType: value.order
  })
  const queryInfo = store.state.system.queryInfo
  pageContentRef.value?.getPageData(queryInfo)
}

const [pageModalRef, defaultInfo, handleNewData, handleEditData] = usePageModal(
  newCb,
  editCb
)

const [pageContentRef, handleResetClick, handleSearchClick] = usePageSearch()

return (_ctx: any,_cache: any) => {
  const _component_el_tag = _resolveComponent("el-tag")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(PageSearch, {
      searchFormConfig: _unref(searchFormConfig),
      onResetBtnClick: _unref(handleResetClick),
      onSearchBtnClick: _unref(handleSearchClick)
    }, null, 8, ["searchFormConfig", "onResetBtnClick", "onSearchBtnClick"]),
    _createVNode(PageContent, {
      ref_key: "pageContentRef",
      ref: pageContentRef,
      contentTableConfig: _unref(contentTableConfig),
      pageName: "oa",
      deleteTip: "确认删除此项吗？",
      onSortChange: handleSortChange,
      onNewBtnClick: _unref(handleNewData),
      onEditBtnClick: _unref(handleEditData)
    }, {
      type: _withCtx((scope) => [
        (scope.row.type === 1)
          ? (_openBlock(), _createBlock(_component_el_tag, {
              key: 0,
              size: "mini",
              type: "primary"
            }, {
              default: _withCtx(() => [
                _createTextVNode("公众号")
              ]),
              _: 1
            }))
          : (scope.row.type === 2)
            ? (_openBlock(), _createBlock(_component_el_tag, {
                key: 1,
                size: "mini",
                type: "success"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("视频号")
                ]),
                _: 1
              }))
            : (scope.row.type === 3)
              ? (_openBlock(), _createBlock(_component_el_tag, {
                  key: 2,
                  size: "mini",
                  type: "warning"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("服务号")
                  ]),
                  _: 1
                }))
              : (scope.row.type === 4)
                ? (_openBlock(), _createBlock(_component_el_tag, {
                    key: 3,
                    size: "mini",
                    type: "danger"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("订阅号")
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
      ]),
      certifiedStatus: _withCtx((scope) => [
        (scope.row.certifiedStatus === 0)
          ? (_openBlock(), _createBlock(_component_el_tag, {
              key: 0,
              size: "mini",
              type: "primary"
            }, {
              default: _withCtx(() => [
                _createTextVNode("未认证")
              ]),
              _: 1
            }))
          : (scope.row.certifiedStatus === 1)
            ? (_openBlock(), _createBlock(_component_el_tag, {
                key: 1,
                size: "mini",
                type: "success"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("已认证")
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["contentTableConfig", "onNewBtnClick", "onEditBtnClick"]),
    _createVNode(PageModal, {
      ref_key: "pageModalRef",
      ref: pageModalRef,
      defaultInfo: _unref(defaultInfo),
      modalConfig: _unref(modalConfig),
      title: modalTitle.value,
      pageName: "oa",
      validOtherInfo: () => true
    }, null, 8, ["defaultInfo", "modalConfig", "title"])
  ]))
}
}

})